import React from 'react';
import {Input, Select, Form, Modal, InputNumber, message} from 'antd';
import moment from 'moment';
import {AxiosEsb} from "../../../utils";
const { Search } = Input;


const formItemLayout = {
  labelCol: {
    span: 6,
  },
  wrapperCol: {
    span: 14,
  },
}

const formLargeItemLayout = {
  labelCol: {
    span: 3,
  },
  wrapperCol: {
    span: 19,
  },
}

const modalMaster = ({visible,type,item = {},sapNo,onOk,onCancel,getSapNo,form: {getFieldDecorator,validateFields,getFieldsValue,setFieldsValue
	},}) => {
	console.log("item",item)
	function handleOk () {
		validateFields((err, values) => {

		if(err){return }

	  //如果是 Select InputNumber 作为输入组件；如果不填返回的是 undefined，应该变成 null
      //if(values.cid == item.cid){delete values.cid; } else {if(typeof(values.cid)=="undefined"){values.cid = null; }}



		if (Object.getOwnPropertyNames(values).length == 0) {
		  onCancel()
		  return
		}

		values.apply_quota = values.apply_quota *100;  //把值放大100倍，从分变成元。
	  if(item.id){values.id = item.id} //如果是变更，item有内容，把id给到values

		onOk(values)

	  })
	}

	function handleGetSapNo(value){
		//let json=getSapNo(value);
		//item.sap_no = "1232456"

			//value 是传过来的参数
			//getState 可获取当前store的状态
			//通过esb查SAP号
			let Axios = AxiosEsb();
		Axios.post('/api/sap/queryCustomerSapNo',{STCEG:value}).then((res)=>{
			if (res.data.status == true){
				setFieldsValue({sap_no:res.data.data.sapNO,enterprise_name:res.data.data.customerName});
				return '查询成功';
			}

		}).catch((err)=>{
			message.error( err,10);
			return '错误'
		})


	}
	const modalOpts = {
	  title: `${type === 'create' ? '新建' : '修改'}`,
	  visible,
	  onOk: handleOk,
	  onCancel,keyboard:false,maskClosable:false,
	  wrapClassName: 'vertical-center-modal',
	  width: 520,
	  //okText: '确认',
      //cancelText: '取消',
	}

   //sap_no位数检查
	const compareToSAPNOLength = (rule, value, callback) => {
		if (value.length <10) {
			callback('SAP_NO 位数不能低于10位');
		} else {
			callback();
		}
	};

	return (
	  <Modal {...modalOpts}>
		<Form layout="horizontal">

		<Form.Item label={'客户'} {...formItemLayout} >
		   {getFieldDecorator('enterprise_name', {
				initialValue: item.enterprise_name,
				rules: [{ required: true, message: '客户的公司名称' }],
			  }
			)(
			<Input disabled={type != 'create'} />
			)}
		</Form.Item>
		<Form.Item label={'社会信用代码'} {...formItemLayout} >
		   {getFieldDecorator('social_credit_code', {
				initialValue: item.social_credit_code,
			    rules: [{ required: true, message: '社会信用代码 必填' }],
			  }
			)(
			//<Input disabled={type != 'create'} onBlur={console.log('测试')}/>
			<Search disabled={type != 'create'} onSearch={value => handleGetSapNo(value)} />
			)}
		</Form.Item>
			<Form.Item label={'SAP编码'} {...formItemLayout} >
				{getFieldDecorator('sap_no', {
						initialValue: item.sap_no,
						rules: [{ required: true, message: 'SAP编码 必填' },{validator:compareToSAPNOLength}],
					}
				)(
					<Input disabled={type != 'create'}/>
				)}
			</Form.Item>

		<Form.Item label={'申请额度(元)'} {...formItemLayout} >
			{getFieldDecorator('apply_quota', {
					initialValue:type == 'update'? item.apply_quota /100:null,
				rules: [{ required: true, message: '申请额度 必填' }],
				}
			)(
				<InputNumber style={{width:'100%'}}
					formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
					parser={value => value.replace(/\$\s?|(,*)/g, '')}
				    precision ={2}
				/>
			)}
		</Form.Item>
			<Form.Item label={'分公司编码'} {...formItemLayout} >
				{getFieldDecorator('subcompany_code', {
					initialValue: item.subcompany_code,
					}
				)(
					<Input  />
				)}
			</Form.Item>
		<Form.Item label={'分公司'} {...formItemLayout} >
			{getFieldDecorator('subcompany', {
					initialValue: item.subcompany,
					rules: [{ required: true, message: '分公司名称' }],
				}
			)(
				<Input  />
			)}
		</Form.Item>

		<Form.Item label={'业务经办人'} {...formItemLayout} >
				{getFieldDecorator('bizperson', {
						initialValue: item.bizperson,
						rules: [{ required: true, message: '业务经办人名称' }],
					}
				)(
					<Input  />
				)}
		</Form.Item>

		</Form>
	  </Modal>
	)
}


const ModalRender = Form.create()(modalMaster);


export default ModalRender;
